/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithTypeName
 */
export interface WithTypeNameOptional {
  /**
   *
   * @type {string}
   * @memberof WithTypeName
   */
  typeName?: string;
}

export interface WithTypeName extends WithTypeNameOptional {
  /**
   *
   * @type {string}
   * @memberof WithTypeName
   */
  typeName?: string;
}

export interface WithTypeNameTrackedI {
  /**
   *
   * @type {string}
   * @memberof WithTypeName
   */
  typeName?: string;
  typeNameIsSet: boolean;
}

transformDatesMap.set("WithTypeName", function (model: WithTypeName) {});

export type WithTypeNameMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var WithTypeNameMeta: WithTypeNameMetaI = {} as WithTypeNameMetaI;
WithTypeNameMeta = typeMeta("WithTypeName", {
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
});

const metaI = WithTypeNameMeta;

registerMeta(() => {});

export class WithTypeNameTracked implements WithTypeNameTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  constructor(config?: WithTypeNameOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithTypeNameOptional,
    options?: AssignOptions,
  ): WithTypeNameTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithTypeNameTrackedI {
    const cloned = {} as WithTypeNameTrackedI;
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithTypeNameTrackedI {
    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    return this;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithTypeNameMeta.typeName,
      WithTypeNameMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
